import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { Hidden } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import FlexBox from 'shared/components/FlexBox';
import { BENEFITS } from 'shared/constants';
import Customers from 'static_pages/foodProgram/Customers';
import Ratings from 'static_pages/home/components/Hero/Ratings';
import Container from 'system/components/Container';

interface Props {
  rating: number;
}

const HeroBenefits = ({ rating }: Props) => {
  const { t } = useTranslation('common');
  return (
    <Box
      bgcolor={'#F8FBE5'}
      display="flex"
      alignItems="center"
      height={{ xs: 'auto', lg: '93px' }}
      width="100%"
    >
      <Container size="sm">
        <Box
          display="flex"
          flexDirection={{ xs: 'column', lg: 'row' }}
          alignItems="center"
          justifyContent="center"
        >
          <FlexBox
            flexDirection={{ xs: 'column', lg: 'row' }}
            justifyContent="center"
            alignItems="center"
          >
            <CustomerCountText textAlign="center" component="span">
              {t('benefits.customerCount', {
                count: BENEFITS.CUSTOMER_COUNT,
              })}
            </CustomerCountText>
            <Box
              pl={{ xs: 1, lg: 4 }}
              pt={{ xs: 2, lg: 0 }}
              pr={{ xs: 1, lg: 3 }}
            >
              <Customers />
            </Box>
          </FlexBox>
          <Hidden mdDown implementation="css">
            <Divider />
          </Hidden>
          <FlexBox
            ml={{ xs: 0, lg: 1 }}
            flexDirection={{ xs: 'column', lg: 'row' }}
          >
            <Ratings rating={rating} />
          </FlexBox>
        </Box>
      </Container>
    </Box>
  );
};

const Divider = styled.div`
  width: 90vw;
  height: 1px;
  background-color: #d0d0d0;
  margin-top: ${({ theme }) => theme.spacing(2)}px;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: 1px;
    margin-top: 0px;
    height: 70px;
  }
`;

const CustomerCountText = styled(Typography)`
  font-weight: 700;
  font-size: 14px;
  min-width: 100px;
  line-height: 1.5;
  color: #565b58;
  padding-top: ${({ theme }) => theme.spacing(3)}px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    font-size: 16px;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 18px;
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding-top: 0px;
    margin-right: ${({ theme }) => theme.spacing(1)}px;
  }
`;

export default HeroBenefits;
